
const initialState = {
  quantityKids: 0,
};

const quantityKid = ( state = initialState, action ) => {
  switch (action.type) {
    case 'ADD_QUANTITY_KID':
      return {
        ...state,
        quantityKids: action.quantity,
      };
    case 'REMOVE_QUANTITY_KID':
      return {
        ...state,
        quantityKids: action.quantity,
      };
    default:
      return state;
  }
};

export default quantityKid;